import { RootContainer } from '../../../../core/root_container';
import { CategorySJsEnv } from '../../models/category_s_js_env';
import {
  RrBodyCategorySExternalSite,
  RrBodyCategorySNormal,
  RrBodyCategorySLeftSide
} from './rr_body';

export class CategorySContainer extends RootContainer<CategorySJsEnv> {
  constructor(model: CategorySJsEnv) {
    super();

    this.mount(RrBodyCategorySExternalSite, model.rrAreaProfileCategorySExternalSite.placementName);
    this.mount(RrBodyCategorySNormal, model.rrAreaProfileCategorySNormal.placementName);
    this.mount(RrBodyCategorySLeftSide, model.rrAreaProfileCategorySLeftSide.placementName);

    // 初回描画
    this.update(model);

    const WindowCarousel = window._carousel;
    new WindowCarousel( // NOSONAR
      `#${model.rrAreaProfileCategorySExternalSite.placementName},#${model.rrAreaProfileCategorySNormal.placementName},#${model.rrAreaProfileCategorySLeftSide.placementName}`
    );

    // 専門検索戻りアンカースクロール
    if (location.hash != null) {
      const urlHashAnchorId = location.hash.slice(1);
      const scrollTarget = document.getElementById(urlHashAnchorId);
      if (scrollTarget != null) {
        scrollTarget.scrollIntoView();
      }
    }
  }
}
